module.exports = __webpack_public_path__ + "ic-appTech.svg?e6559bcf391cdd5063677a364d40c725";